import { Breadcrumb, Select, Input } from "antd";
import { t } from "i18next";
import { BackIcon } from "../../../../asset";
import React, { useState } from 'react';
import style from './skillSetPage.module.css';
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { useSkillset } from "./SkillsetPage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import { useLocation } from 'react-router-dom'

export default function SkillSetAdd() {

    const navigate = useNavigate();
    const backToSkillsetList = () => {
        navigate(ROUTES.SKILLSET.LIST)
    }

    const { state } = useLocation()

    const {
        doPostSkillset,
        onChange,
        successModalOpen,
        skillsetType,
        showConfirm,
        setShowConfirm,
        isClear,
        skillsetTypeError,
        skillsetNameError,
        skillsetDescriptionError
    } = useSkillset();

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <ModalConfirmLeave
                visible={showConfirm}
                action={() => setShowConfirm(false)}
                route={ROUTES.SKILLSET.LIST}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => navigate(ROUTES.SKILLSET.LIST)}
                closable={false}
                width={280}
                className={style.successModal}
                okText="Ok"
                title="Success"
                description={`New Skillset ${skillsetType} has been added`}
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Skillset`}
                menuLevel4={`Add Skillset`}
            />

            <div className="flex items-center gap-[22px] cursor-pointer"  onClick={!isClear() ? () => setShowConfirm(true) : () => backToSkillsetList()}>
                <img src={BackIcon} alt="back-icon" />
                <h1 className='font-sans-bold text-2xl' id='title'>{t("SKILLSET_ADD:TITLE")}</h1>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("SKILLSET_ADD:SKILLSET")}</h3>

                <div className="flex flex-col gap-[16px]">
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("SKILLSET_ADD:SKILLSET_TYPE_LABEL")}</label>
                        <Select
                            className='mt-[8px]'
                            placeholder={t("SKILLSET_ADD:SKILLSET_TYPE_PLACEHOLDER")}
                            style={skillsetTypeError ? { width: 350, borderColor: `#FF0000`, borderWidth: 1 } : { width: 350, border: `none` }}
                            options={[
                                { value: 'Container', label: 'Container' },
                                { value: 'Resistance', label: 'Resistance' },
                                { value: 'Physical Property', label: 'Physical Property' },
                            ]}
                            onChange={(event) => onChange(event, 'skillset_type')}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${skillsetTypeError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("SKILLSET_ADD:SKILLSET_NAME_LABEL")}</label>
                        <Input style={{ width: 350 }} placeholder={"Type Skillset Name"} className={`mt-[8px] ${skillsetNameError ? `border-[1px] border-[#FF0000]` : ''}`} maxLength={128} onChange={(event) => onChange(event, 'skillset_name')} />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${skillsetNameError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("SKILLSET_ADD:DESCRIPTION_LABEL")}</label>
                        <TextArea
                            style={skillsetDescriptionError ? { width: 350, resize: 'none', borderColor: `#FF0000`, borderWidth: 1 } : { width: 350, resize: 'none' }}
                            onChange={(event) => onChange(event, 'description')}
                            maxLength={256}
                            placeholder={"Type Description"}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${skillsetDescriptionError ? `visible` : 'hidden'}`}>This field is required</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => doPostSkillset(state.depotId)}>
                    {t("SKILLSET_ADD:ADD_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={!isClear() ? () => setShowConfirm(true) : () => backToSkillsetList()}>
                    {t("SKILLSET_ADD:CANCEL_BUTTON")}
                </button>
            </div>

        </div>
    )
}
